import React from 'react';
import { Box, Container, Typography, Link, Stack, Divider } from '@mui/material';
import { PlayCircleOutline, Email } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'rgba(255, 255, 255, 0.05)',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        {/* Logo and Branding */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
            <PlayCircleOutline
              sx={{
                fontSize: 32,
                color: 'primary.main',
                mr: 1,
              }}
            />
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              AutoReelr
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            AI-Powered Faceless Reel Creation Platform
          </Typography>
        </Box>

        {/* Navigation Links */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={3}
          justifyContent="center"
          sx={{ mb: 4 }}
        >
          <Link
            component={RouterLink}
            to="/about"
            color="text.secondary"
            sx={{
              textDecoration: 'none',
              '&:hover': {
                color: 'primary.main',
                textDecoration: 'none',
              },
            }}
          >
            About
          </Link>
          <Link
            component={RouterLink}
            to="/contact"
            color="text.secondary"
            sx={{
              textDecoration: 'none',
              '&:hover': {
                color: 'primary.main',
                textDecoration: 'none',
              },
            }}
          >
            Contact
          </Link>
          <Link
            component={RouterLink}
            to="/terms"
            color="text.secondary"
            sx={{
              textDecoration: 'none',
              '&:hover': {
                color: 'primary.main',
                textDecoration: 'none',
              },
            }}
          >
            Terms of Service
          </Link>
          <Link
            component={RouterLink}
            to="/privacy"
            color="text.secondary"
            sx={{
              textDecoration: 'none',
              '&:hover': {
                color: 'primary.main',
                textDecoration: 'none',
              },
            }}
          >
            Privacy Policy
          </Link>
        </Stack>

        <Divider sx={{ mb: 4, borderColor: 'rgba(255, 255, 255, 0.05)' }} />

        {/* Copyright */}
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mb: 2 }}
        >
          © {currentYear} AutoReelr by Jonkai Ventures. All rights reserved.
        </Typography>

        {/* Tagline */}
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mb: 4 }}
        >
          Create AI reels • Multi-platform publishing • Advanced analytics
        </Typography>

        {/* Company Information */}
        <Box
          sx={{
            textAlign: 'center',
            fontSize: '0.875rem',
            color: 'rgba(255, 255, 255, 0.6)',
            lineHeight: 1.6,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
            AutoReelr is a brand of:
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            Jonkai Ventures OÜ
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            Tartu mnt 67/1-13b, 10115 - Harju maakond, Tallinn, Kesklinna linnaosa
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Registrikood 17322110 - Estonia EU
          </Typography>
          <Link
            href="mailto:info@autoreelr.com"
            sx={{
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            <Email sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'middle' }} />
            info@autoreelr.com
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;